import React, { useState } from 'react';

import { encode, decode } from 'html-entities';

import { ClosableBadge, EditInline } from 'components/UI';

const MAX_GOAL_LENGTH = 128;

interface IGoalProps {
  goal: ICarePlanGoal;
  handleEditGoal: any;
  postEditCarePlan: any;
  dataTestId: string;
  disabled?: boolean;
}

const Goal = ({ goal, handleEditGoal, postEditCarePlan, dataTestId, disabled }: IGoalProps) => {
  const [editing, setEditing] = useState<boolean>(!goal.goal_id);

  const handleSave = async (value: string) => {
    const newGoal = {
      goal_id: goal.goal_id,
      goal: encode(value),
      edit_status: goal.edit_status === 'new' ? 'new' : 'updated'
    };

    const res = await postEditCarePlan({
      data: {
        carePlan: {
          care_plan_id: goal.care_plan_id,
          edit_status: goal.care_plan_id ? 'updated' : 'new',
          goals: [{ ...newGoal }]
        }
      }
    });
    handleEditGoal(res.data.carePlan.goals[0]);
  };

  const handleDelete = async () => {
    const oldGoal = {
      goal_id: goal.goal_id,
      edit_status: 'deleted',
      goal: goal.goal
    };
    await postEditCarePlan({
      data: {
        carePlan: {
          care_plan_id: goal.care_plan_id,
          edit_status: 'updated',
          goals: [{ ...oldGoal }]
        }
      }
    });
    handleEditGoal(oldGoal);
  };

  const handleBlur = () => {
    handleEditGoal();
  };

  return (
    <ClosableBadge
      dataTestId={dataTestId}
      label={
        <EditInline
          defaultValue={decode(goal.goal)}
          onChange={handleSave}
          isEditing={!goal.goal_id}
          onBlur={handleBlur}
          maxLength={MAX_GOAL_LENGTH}
          editingStatus={(editing) => setEditing(editing)}
        />
      }
      onDelete={editing || disabled ? null : handleDelete}
      bg="blue-light"
      className="font-weight-bolder white-space-break-spaces text-left m-1 cursor-pointer"
    />
  );
};

export default Goal;
